import { root } from './destinations';
import * as idEndpoints from './id';

export const destinations = {
  ...root,
  id: {
    ...idEndpoints,
  },
};
